// vendor imports
import "angular";
import * as $ from 'jquery';
import "./vendor/canvg.js";
import "./vendor/howler.js";
import "./vendor/pointer-events-polyfill.js";
import "./vendor/findindex.polyfill.js";
import "./vendor/innersvg.js";
import "pixi.js/bin/pixi.js";
import "snapsvg/dist/snap.svg.js";
import "./vendor/snapSVGAnimator.js";
import "downloadjs/download.js";
import "angular-animate";
import "./vendor/log-ex-unobtrusive.min.js";
import "ng-stats";
import "ng-resize";
import "angular-hammer";
import "clipboard";
// import 'angulartics'
// import 'angulartics-google-analytics'
import "angular-local-storage";
import "spectrum-colorpicker";
import "angular-spectrum-colorpicker/dist/angular-spectrum-colorpicker.min";

// app imports
import Common from './common/common';
import Components from './components/components';

import { App } from './app';
import AppConfig from './app.config';

// app css
import './app.scss';

/*$.getScript("http://a.dolimg.com/media/en-US/games/html5/gameConfig/isl.js", function (data, textStatus, jqxhr) {
  window.gameStart()
});*/

window.gameStart = function() {
  angular
    .module('app', [
      'log.ex.uo',
      'angularStats',
      'ngResize',
      'ngAnimate',
      'hmTouchEvents',
      'LocalStorageModule',
      'angularSpectrumColorpicker',
      Common.name,
      Components.name
    ])
    .config(AppConfig)
    .value('$routerRootComponent', 'app') // top level router component, contains the intial routes and views
    .component('heroCreator', new App());

  // start angular using code instead of ng-app declaration in the index.html
  angular.bootstrap(document.querySelector('hero-creator'), ['app'], {
    strictDi: true
  });

  $(document).ready(function() {
    window.PointerEventsPolyfill.initialize({});
  });
};



/** WEBPACK FOOTER **
 ** ./src/index.release.ts
 **/